export const siteModuleTranslations = {
  en: {
    "Shipping Worldwide": "Shipping Worldwide",
    "Footer.openSource.title": "Open Source",
    "Footer.openSource.github": "GitHub Organization",
    "Footer.mediaKit": "Media Kit",
    "Supported Crypto": "Supported Crypto",
    "supportedCrypto.seoTitle": "Supported Crypto Assets | LUKKEY",
    "supportedCrypto.seoDescription":
      "Search LUKKEY-supported blockchains, coins, and tokens available in the current LUKKEY app asset list.",
    "supportedCrypto.badge": "Current LUKKEY app list",
    "supportedCrypto.title": "Search supported crypto",
    "supportedCrypto.search.placeholder": "Search BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Search supported crypto assets",
    "supportedCrypto.search.clear": "Clear search",
    "supportedCrypto.filter.chain": "Network filter",
    "supportedCrypto.filter.networkLabel": "Network",
    "supportedCrypto.filter.allChains": "All networks",
    "supportedCrypto.filter.all": "All",
    "supportedCrypto.filter.native": "Native",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Asset",
    "supportedCrypto.table.network": "Network",
    "supportedCrypto.table.type": "Type",
    "supportedCrypto.type.native": "Native",
    "supportedCrypto.status.supported": "Supported",
    "supportedCrypto.results.count": "{{count}} assets",
    "supportedCrypto.results.list": "Supported assets list",
    "supportedCrypto.scrollHint": "Scroll for more",
    "supportedCrypto.empty.title": "No matching assets",
    "supportedCrypto.empty.body":
      "Try another coin symbol, token name, or blockchain network.",
    "WarrantySupport.toast.successTitle": "Request submitted",
    "WarrantySupport.toast.dismiss": "Dismiss notification",
    "HelpCenter.tutorials.badge": "Product tutorials",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Watch official setup, app, address book, NFT, firmware, and password tutorials from the Lukkey Tutorials playlist.",
    "HelpCenter.tutorials.playlistCta": "View full playlist",
    "HelpCenter.tutorials.videoCta": "Watch tutorial",
    "WarrantySupport.validation.maxLength": "Maximum {{max}} characters.",
    "WarrantySupport.form.cooldown": "Wait {{seconds}}s",
    "WarrantySupport.validation.cooldown": "Please wait {{seconds}} seconds before submitting another request.",
    "WarrantySupport.validation.email": "Enter a valid email address.",
    "WarrantySupport.validation.required": "This field is required.",
    "home.secureChip.title": "EAL6+ Secure Chip Technology",
    "home.secureChip.description":
      "Equipped with an EAL6+ secure chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.",
    "home.multiAccount.title": "3 Wallets in One Lukkey",
    "home.multiAccount.description":
      "Three separate wallets on one device, each with its own recovery phrase.",
    "delivery.seoTitle": "International Delivery Timeframes | LUKKEY",
    "delivery.seoDescription":
      "Browse supported regions, delivery timeframes, and shipping costs for international delivery.",
    "delivery.badge": "International Delivery",
    "delivery.title": "Delivery Timeframes",
    "delivery.subtitle":
      "LUKKEY international shipping coverage with estimated delivery timeframes and shipping costs, benchmarked against current market references.",
    "delivery.search.placeholder": "Search country",
    "delivery.table.country": "Country",
    "delivery.table.delivery": "Delivery",
    "delivery.table.cost": "Shipping cost, USD",
    "delivery.filter.allDeliveries": "All delivery ranges",
    "delivery.filter.allCosts": "All shipping costs",
    "delivery.meta":
      "Showing {{count}} supported regions. Page {{page}} of {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} business days",
    "delivery.sortLabel": "Sort",
  },
  zh: {
    "Shipping Worldwide": "全球配送",
    "Footer.openSource.title": "开源",
    "Footer.openSource.github": "GitHub 组织",
    "Footer.mediaKit": "媒体资料包",
    "Supported Crypto": "支持的加密货币",
    "supportedCrypto.seoTitle": "支持的加密货币 | LUKKEY",
    "supportedCrypto.seoDescription":
      "搜索当前 LUKKEY App 资产列表中支持的区块链、数字货币与代币。",
    "supportedCrypto.badge": "当前 LUKKEY App 列表",
    "supportedCrypto.title": "搜索支持的加密货币",
    "supportedCrypto.search.placeholder": "搜索 BTC、USDT、BSC、TRC20...",
    "supportedCrypto.search.label": "搜索支持的加密资产",
    "supportedCrypto.search.clear": "清除搜索",
    "supportedCrypto.filter.chain": "网络筛选",
    "supportedCrypto.filter.networkLabel": "网络",
    "supportedCrypto.filter.allChains": "全部网络",
    "supportedCrypto.filter.all": "全部",
    "supportedCrypto.filter.native": "原生币",
    "supportedCrypto.filter.tokens": "代币",
    "supportedCrypto.table.asset": "资产",
    "supportedCrypto.table.network": "网络",
    "supportedCrypto.table.type": "类型",
    "supportedCrypto.type.native": "原生币",
    "supportedCrypto.status.supported": "已支持",
    "supportedCrypto.results.count": "共 {{count}} 个资产",
    "supportedCrypto.results.list": "支持的资产列表",
    "supportedCrypto.scrollHint": "向下滚动查看更多",
    "supportedCrypto.empty.title": "没有匹配的资产",
    "supportedCrypto.empty.body": "试试其他币种符号、代币名称或区块链网络。",
    "WarrantySupport.toast.successTitle": "请求已提交",
    "WarrantySupport.toast.dismiss": "关闭通知",
    "HelpCenter.tutorials.badge": "产品教学",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "观看 Lukkey Tutorials 播放列表中的官方设置、App、地址簿、NFT、固件和密码教学视频。",
    "HelpCenter.tutorials.playlistCta": "查看完整播放列表",
    "HelpCenter.tutorials.videoCta": "观看教学",
    "WarrantySupport.form.cooldown": "请等待 {{seconds}} 秒",
    "WarrantySupport.validation.cooldown": "请等待 {{seconds}} 秒后再提交新的支持请求。",
    "WarrantySupport.validation.maxLength": "最多 {{max}} 个字符。",
    "WarrantySupport.validation.email": "请输入有效的邮箱地址。",
    "WarrantySupport.validation.required": "此项为必填。",
    "home.secureChip.title": "EAL6+ 安全芯片技术",
    "home.secureChip.description":
      "搭载 EAL6+ 安全芯片，为你的数字资产提供更强的防护，抵御未授权访问与网络威胁。",
    "home.multiAccount.title": "一台 Lukkey，3 个钱包",
    "home.multiAccount.description":
      "一台设备内支持 3 个独立钱包，各自拥有单独的助记词。",
    "delivery.seoTitle": "国际配送时效 | LUKKEY",
    "delivery.seoDescription":
      "查看支持配送的地区、预计配送时效以及国际配送运费。",
    "delivery.badge": "国际配送",
    "delivery.title": "配送时效",
    "delivery.subtitle":
      "查看 LUKKEY 的国际配送覆盖范围、预计送达时间和运费，并参考当前市场信息。",
    "delivery.search.placeholder": "搜索国家/地区",
    "delivery.table.country": "国家/地区",
    "delivery.table.delivery": "时效",
    "delivery.table.cost": "运费（美元）",
    "delivery.filter.allDeliveries": "全部时效区间",
    "delivery.filter.allCosts": "全部运费",
    "delivery.meta": "共显示 {{count}} 个支持地区。第 {{page}} / {{totalPages}} 页。",
    "delivery.range.businessDays": "{{min}}-{{max}} 个工作日",
    "delivery.sortLabel": "排序",
  },
  "zh-TW": {
    "Shipping Worldwide": "全球配送",
    "Footer.openSource.title": "開源",
    "Footer.openSource.github": "GitHub 組織",
    "Footer.mediaKit": "媒體資料包",
    "Supported Crypto": "支援的加密貨幣",
    "supportedCrypto.seoTitle": "支援的加密貨幣 | LUKKEY",
    "supportedCrypto.seoDescription":
      "搜尋目前 LUKKEY App 資產清單中支援的區塊鏈、數位貨幣與代幣。",
    "supportedCrypto.badge": "目前 LUKKEY App 清單",
    "supportedCrypto.title": "搜尋支援的加密貨幣",
    "supportedCrypto.search.placeholder": "搜尋 BTC、USDT、BSC、TRC20...",
    "supportedCrypto.search.label": "搜尋支援的加密資產",
    "supportedCrypto.search.clear": "清除搜尋",
    "supportedCrypto.filter.chain": "網路篩選",
    "supportedCrypto.filter.networkLabel": "網路",
    "supportedCrypto.filter.allChains": "全部網路",
    "supportedCrypto.filter.all": "全部",
    "supportedCrypto.filter.native": "原生幣",
    "supportedCrypto.filter.tokens": "代幣",
    "supportedCrypto.table.asset": "資產",
    "supportedCrypto.table.network": "網路",
    "supportedCrypto.table.type": "類型",
    "supportedCrypto.type.native": "原生幣",
    "supportedCrypto.status.supported": "已支援",
    "supportedCrypto.results.count": "共 {{count}} 個資產",
    "supportedCrypto.results.list": "支援的資產列表",
    "supportedCrypto.scrollHint": "向下捲動查看更多",
    "supportedCrypto.empty.title": "沒有符合的資產",
    "supportedCrypto.empty.body": "試試其他幣種符號、代幣名稱或區塊鏈網路。",
    "WarrantySupport.toast.successTitle": "請求已提交",
    "WarrantySupport.toast.dismiss": "關閉通知",
    "HelpCenter.tutorials.badge": "產品教學",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "觀看 Lukkey Tutorials 播放清單中的官方設定、App、地址簿、NFT、韌體與密碼教學影片。",
    "HelpCenter.tutorials.playlistCta": "查看完整播放清單",
    "HelpCenter.tutorials.videoCta": "觀看教學",
    "WarrantySupport.form.cooldown": "請等待 {{seconds}} 秒",
    "WarrantySupport.validation.cooldown": "請等待 {{seconds}} 秒後再提交新的支援請求。",
    "WarrantySupport.validation.maxLength": "最多 {{max}} 個字元。",
    "WarrantySupport.validation.email": "請輸入有效的電子郵件地址。",
    "WarrantySupport.validation.required": "此欄位為必填。",
    "home.secureChip.title": "EAL6+ 安全晶片技術",
    "home.secureChip.description":
      "搭載 EAL6+ 安全晶片，為你的數位資產提供更強韌的防護，抵禦未授權存取與網路威脅。",
    "home.multiAccount.title": "一台 Lukkey，3 組錢包",
    "home.multiAccount.description":
      "一台裝置支援 3 組獨立錢包，每組都有各自的助記詞。",
    "delivery.seoTitle": "國際配送時效 | LUKKEY",
    "delivery.seoDescription":
      "查看支援配送的地區、預估配送時效與國際運費。",
    "delivery.badge": "國際配送",
    "delivery.title": "配送時效",
    "delivery.subtitle":
      "查看 LUKKEY 的國際配送涵蓋範圍、預估送達時間與運費，並參考目前市場資訊。",
    "delivery.search.placeholder": "搜尋國家/地區",
    "delivery.table.country": "國家/地區",
    "delivery.table.delivery": "時效",
    "delivery.table.cost": "運費（美元）",
    "delivery.filter.allDeliveries": "全部時效區間",
    "delivery.filter.allCosts": "全部運費",
    "delivery.meta": "共顯示 {{count}} 個支援地區。第 {{page}} / {{totalPages}} 頁。",
    "delivery.range.businessDays": "{{min}}-{{max}} 個工作天",
    "delivery.sortLabel": "排序",
  },
  fr: {
    "Shipping Worldwide": "Livraison mondiale",
    "Footer.openSource.title": "Open source",
    "Footer.openSource.github": "Organisation GitHub",
    "Footer.mediaKit": "Kit média",
    "Supported Crypto": "Cryptos prises en charge",
    "supportedCrypto.seoTitle": "Cryptos prises en charge | LUKKEY",
    "supportedCrypto.seoDescription":
      "Recherchez les blockchains, coins et tokens pris en charge dans la liste actuelle de l'app LUKKEY.",
    "supportedCrypto.badge": "Liste actuelle de l'app LUKKEY",
    "supportedCrypto.title": "Rechercher une crypto prise en charge",
    "supportedCrypto.search.placeholder": "Rechercher BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Rechercher des cryptoactifs pris en charge",
    "supportedCrypto.search.clear": "Effacer la recherche",
    "supportedCrypto.filter.chain": "Filtre réseau",
    "supportedCrypto.filter.networkLabel": "Réseau",
    "supportedCrypto.filter.allChains": "Tous les réseaux",
    "supportedCrypto.filter.all": "Tous",
    "supportedCrypto.filter.native": "Natif",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Actif",
    "supportedCrypto.table.network": "Réseau",
    "supportedCrypto.table.type": "Type",
    "supportedCrypto.type.native": "Natif",
    "supportedCrypto.status.supported": "Pris en charge",
    "supportedCrypto.empty.title": "Aucun actif correspondant",
    "supportedCrypto.empty.body":
      "Essayez un autre symbole, nom de token ou réseau blockchain.",
    "WarrantySupport.toast.successTitle": "Demande envoyée",
    "WarrantySupport.toast.dismiss": "Fermer la notification",
    "HelpCenter.tutorials.badge": "Tutoriels produit",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Regardez les tutoriels officiels de configuration, d’app, de carnet d’adresses, de NFT, de firmware et de mot de passe dans la playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Voir toute la playlist",
    "HelpCenter.tutorials.videoCta": "Regarder le tutoriel",
    "WarrantySupport.form.cooldown": "Attendre {{seconds}} s",
    "WarrantySupport.validation.cooldown": "Veuillez attendre {{seconds}} secondes avant d’envoyer une autre demande.",
    "WarrantySupport.validation.maxLength": "{{max}} caractères maximum.",
    "WarrantySupport.validation.email": "Saisissez une adresse e-mail valide.",
    "WarrantySupport.validation.required": "Ce champ est obligatoire.",
    "home.secureChip.title": "Technologie de puce sécurisée EAL6+",
    "home.secureChip.description":
      "Équipé d'une puce sécurisée EAL6+, LUKKEY protège efficacement vos actifs numériques contre les accès non autorisés et les menaces en ligne.",
    "home.multiAccount.title": "3 wallets dans un seul Lukkey",
    "home.multiAccount.description":
      "Trois wallets distincts sur un seul appareil, chacun avec sa propre phrase de récupération.",
    "delivery.seoTitle": "Délais de livraison internationale | LUKKEY",
    "delivery.seoDescription":
      "Consultez les régions prises en charge, les délais de livraison et les frais d'expédition internationaux.",
    "delivery.badge": "Livraison internationale",
    "delivery.title": "Délais de livraison",
    "delivery.subtitle":
      "Consultez la couverture d'expédition internationale de LUKKEY, les délais estimés et les frais de livraison, comparés aux références actuelles du marché.",
    "delivery.search.placeholder": "Rechercher un pays",
    "delivery.table.country": "Pays",
    "delivery.table.delivery": "Livraison",
    "delivery.table.cost": "Frais d'expédition, USD",
    "delivery.filter.allDeliveries": "Tous les délais",
    "delivery.filter.allCosts": "Tous les frais",
    "delivery.meta":
      "{{count}} régions prises en charge affichées. Page {{page}} sur {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} jours ouvrés",
    "delivery.sortLabel": "Trier",
  },
  es: {
    "Shipping Worldwide": "Envíos a todo el mundo",
    "Footer.openSource.title": "Código abierto",
    "Footer.openSource.github": "Organización de GitHub",
    "Footer.mediaKit": "Kit de medios",
    "Supported Crypto": "Criptomonedas compatibles",
    "supportedCrypto.seoTitle": "Criptomonedas compatibles | LUKKEY",
    "supportedCrypto.seoDescription":
      "Busca blockchains, monedas y tokens compatibles en la lista actual de activos de la app LUKKEY.",
    "supportedCrypto.badge": "Lista actual de la app LUKKEY",
    "supportedCrypto.title": "Buscar criptomonedas compatibles",
    "supportedCrypto.search.placeholder": "Buscar BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Buscar criptoactivos compatibles",
    "supportedCrypto.search.clear": "Borrar búsqueda",
    "supportedCrypto.filter.chain": "Filtro de red",
    "supportedCrypto.filter.networkLabel": "Red",
    "supportedCrypto.filter.allChains": "Todas las redes",
    "supportedCrypto.filter.all": "Todo",
    "supportedCrypto.filter.native": "Nativa",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Activo",
    "supportedCrypto.table.network": "Red",
    "supportedCrypto.table.type": "Tipo",
    "supportedCrypto.type.native": "Nativa",
    "supportedCrypto.status.supported": "Compatible",
    "supportedCrypto.empty.title": "No hay activos coincidentes",
    "supportedCrypto.empty.body":
      "Prueba con otro símbolo, nombre de token o red blockchain.",
    "WarrantySupport.toast.successTitle": "Solicitud enviada",
    "WarrantySupport.toast.dismiss": "Cerrar notificación",
    "HelpCenter.tutorials.badge": "Tutoriales del producto",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Mira tutoriales oficiales de configuración, app, libreta de direcciones, NFT, firmware y contraseña en la lista Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Ver lista completa",
    "HelpCenter.tutorials.videoCta": "Ver tutorial",
    "WarrantySupport.form.cooldown": "Espera {{seconds}} s",
    "WarrantySupport.validation.cooldown": "Espera {{seconds}} segundos antes de enviar otra solicitud.",
    "WarrantySupport.validation.maxLength": "Máximo {{max}} caracteres.",
    "WarrantySupport.validation.email": "Introduce una dirección de correo válida.",
    "WarrantySupport.validation.required": "Este campo es obligatorio.",
    "home.secureChip.title": "Tecnología de chip seguro EAL6+",
    "home.secureChip.description":
      "Equipado con un chip seguro EAL6+, LUKKEY protege tus activos digitales frente a accesos no autorizados y amenazas cibernéticas.",
    "home.multiAccount.title": "3 wallets en un solo Lukkey",
    "home.multiAccount.description":
      "Tres wallets independientes en un mismo dispositivo, cada una con su propia frase de recuperación.",
    "delivery.seoTitle": "Plazos de envío internacional | LUKKEY",
    "delivery.seoDescription":
      "Consulta las regiones disponibles, los plazos de entrega y los costes de envío internacional.",
    "delivery.badge": "Envío internacional",
    "delivery.title": "Plazos de entrega",
    "delivery.subtitle":
      "Consulta la cobertura de envío internacional de LUKKEY, los plazos estimados y los costes de envío según las referencias actuales del mercado.",
    "delivery.search.placeholder": "Buscar país",
    "delivery.table.country": "País",
    "delivery.table.delivery": "Entrega",
    "delivery.table.cost": "Coste de envío, USD",
    "delivery.filter.allDeliveries": "Todos los plazos",
    "delivery.filter.allCosts": "Todos los costes",
    "delivery.meta":
      "Mostrando {{count}} regiones compatibles. Página {{page}} de {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} días laborables",
    "delivery.sortLabel": "Ordenar",
  },
  ar: {
    "Shipping Worldwide": "شحن إلى جميع أنحاء العالم",
    "Footer.openSource.title": "مفتوح المصدر",
    "Footer.openSource.github": "منظمة GitHub",
    "Footer.mediaKit": "الحزمة الإعلامية",
    "Supported Crypto": "العملات الرقمية المدعومة",
    "supportedCrypto.seoTitle": "العملات الرقمية المدعومة | LUKKEY",
    "supportedCrypto.seoDescription":
      "ابحث عن سلاسل البلوكشين والعملات والتوكنات المدعومة في قائمة أصول تطبيق LUKKEY الحالية.",
    "supportedCrypto.badge": "قائمة تطبيق LUKKEY الحالية",
    "supportedCrypto.title": "ابحث عن العملات المدعومة",
    "supportedCrypto.search.placeholder": "ابحث عن BTC أو USDT أو Ethereum أو Solana...",
    "supportedCrypto.search.label": "البحث في الأصول الرقمية المدعومة",
    "supportedCrypto.search.clear": "مسح البحث",
    "supportedCrypto.filter.chain": "تصفية الشبكة",
    "supportedCrypto.filter.networkLabel": "الشبكة",
    "supportedCrypto.filter.allChains": "كل الشبكات",
    "supportedCrypto.filter.all": "الكل",
    "supportedCrypto.filter.native": "أصلية",
    "supportedCrypto.filter.tokens": "توكنات",
    "supportedCrypto.table.asset": "الأصل",
    "supportedCrypto.table.network": "الشبكة",
    "supportedCrypto.table.type": "النوع",
    "supportedCrypto.type.native": "أصلية",
    "supportedCrypto.status.supported": "مدعوم",
    "supportedCrypto.empty.title": "لا توجد أصول مطابقة",
    "supportedCrypto.empty.body":
      "جرّب رمز عملة أو اسم توكن أو شبكة بلوكشين أخرى.",
    "WarrantySupport.toast.successTitle": "تم إرسال الطلب",
    "WarrantySupport.toast.dismiss": "إغلاق الإشعار",
    "HelpCenter.tutorials.badge": "دروس المنتج",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "شاهد دروس الإعداد والتطبيق ودفتر العناوين وNFT والبرامج الثابتة وكلمة المرور الرسمية من قائمة Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "عرض القائمة الكاملة",
    "HelpCenter.tutorials.videoCta": "مشاهدة الدرس",
    "WarrantySupport.form.cooldown": "انتظر {{seconds}} ث",
    "WarrantySupport.validation.cooldown": "يرجى الانتظار {{seconds}} ثانية قبل إرسال طلب آخر.",
    "WarrantySupport.validation.maxLength": "الحد الأقصى {{max}} حرفًا.",
    "WarrantySupport.validation.email": "أدخل عنوان بريد إلكتروني صالحًا.",
    "WarrantySupport.validation.required": "هذا الحقل مطلوب.",
    "home.secureChip.title": "تقنية الشريحة الآمنة +EAL6",
    "home.secureChip.description":
      "مزود بشريحة أمان EAL6+ لحماية قوية لأصولك الرقمية من الوصول غير المصرح به والتهديدات السيبرانية.",
    "home.multiAccount.title": "3 محافظ في جهاز Lukkey واحد",
    "home.multiAccount.description":
      "ثلاث محافظ منفصلة على جهاز واحد، ولكل منها عبارة استرداد خاصة بها.",
    "delivery.seoTitle": "أوقات الشحن الدولي | LUKKEY",
    "delivery.seoDescription":
      "تصفح المناطق المدعومة وأوقات التسليم وتكاليف الشحن الدولي.",
    "delivery.badge": "شحن دولي",
    "delivery.title": "أوقات التسليم",
    "delivery.subtitle":
      "اطّلع على تغطية الشحن الدولي من LUKKEY وأوقات التسليم التقديرية وتكاليف الشحن بالاستناد إلى مراجع السوق الحالية.",
    "delivery.search.placeholder": "ابحث عن دولة",
    "delivery.table.country": "الدولة",
    "delivery.table.delivery": "التسليم",
    "delivery.table.cost": "تكلفة الشحن، دولار",
    "delivery.filter.allDeliveries": "كل نطاقات التسليم",
    "delivery.filter.allCosts": "كل تكاليف الشحن",
    "delivery.meta":
      "يتم عرض {{count}} منطقة مدعومة. الصفحة {{page}} من {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} أيام عمل",
    "delivery.sortLabel": "ترتيب",
  },
  ja: {
    "Shipping Worldwide": "世界配送",
    "Footer.openSource.title": "オープンソース",
    "Footer.openSource.github": "GitHub 組織",
    "Footer.mediaKit": "メディアキット",
    "Supported Crypto": "対応暗号資産",
    "supportedCrypto.seoTitle": "対応暗号資産 | LUKKEY",
    "supportedCrypto.seoDescription":
      "現在の LUKKEY アプリ資産リストで対応しているブロックチェーン、コイン、トークンを検索できます。",
    "supportedCrypto.badge": "現在の LUKKEY アプリリスト",
    "supportedCrypto.title": "対応暗号資産を検索",
    "supportedCrypto.search.placeholder": "BTC、USDT、BSC、TRC20 を検索...",
    "supportedCrypto.search.label": "対応暗号資産を検索",
    "supportedCrypto.search.clear": "検索をクリア",
    "supportedCrypto.filter.chain": "ネットワークフィルター",
    "supportedCrypto.filter.networkLabel": "ネットワーク",
    "supportedCrypto.filter.allChains": "すべてのネットワーク",
    "supportedCrypto.filter.all": "すべて",
    "supportedCrypto.filter.native": "ネイティブ",
    "supportedCrypto.filter.tokens": "トークン",
    "supportedCrypto.table.asset": "資産",
    "supportedCrypto.table.network": "ネットワーク",
    "supportedCrypto.table.type": "タイプ",
    "supportedCrypto.type.native": "ネイティブ",
    "supportedCrypto.status.supported": "対応済み",
    "supportedCrypto.empty.title": "一致する資産がありません",
    "supportedCrypto.empty.body":
      "別のコインシンボル、トークン名、またはブロックチェーンネットワークを試してください。",
    "WarrantySupport.toast.successTitle": "リクエストを送信しました",
    "WarrantySupport.toast.dismiss": "通知を閉じる",
    "HelpCenter.tutorials.badge": "製品チュートリアル",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Lukkey Tutorials プレイリストで、設定、アプリ、アドレス帳、NFT、ファームウェア、パスワードの公式動画を視聴できます。",
    "HelpCenter.tutorials.playlistCta": "プレイリストを見る",
    "HelpCenter.tutorials.videoCta": "チュートリアルを見る",
    "WarrantySupport.form.cooldown": "{{seconds}} 秒待機",
    "WarrantySupport.validation.cooldown": "別のリクエストを送信する前に {{seconds}} 秒お待ちください。",
    "WarrantySupport.validation.maxLength": "最大 {{max}} 文字です。",
    "WarrantySupport.validation.email": "有効なメールアドレスを入力してください。",
    "WarrantySupport.validation.required": "この項目は必須です。",
    "home.secureChip.title": "EAL6+ セキュアチップ技術",
    "home.secureChip.description":
      "EAL6+ セキュアチップを搭載し、不正アクセスやサイバー脅威から大切なデジタル資産を強力に保護します。",
    "home.multiAccount.title": "1 台の Lukkey に 3 つのウォレット",
    "home.multiAccount.description":
      "1 台のデバイスで 3 つの独立したウォレットを管理でき、それぞれに専用のリカバリーフレーズがあります。",
    "delivery.seoTitle": "国際配送の目安 | LUKKEY",
    "delivery.seoDescription":
      "対応地域、配送目安、国際配送コストを確認できます。",
    "delivery.badge": "国際配送",
    "delivery.title": "配送目安",
    "delivery.subtitle":
      "LUKKEY の国際配送対応地域、想定配送日数、送料を現在の市場参考値に基づいて確認できます。",
    "delivery.search.placeholder": "国名で検索",
    "delivery.table.country": "国・地域",
    "delivery.table.delivery": "配送目安",
    "delivery.table.cost": "送料（USD）",
    "delivery.filter.allDeliveries": "すべての配送日数",
    "delivery.filter.allCosts": "すべての送料",
    "delivery.meta": "対応地域 {{count}} 件を表示中。{{page}} / {{totalPages}} ページ。",
    "delivery.range.businessDays": "{{min}}-{{max}} 営業日",
    "delivery.sortLabel": "並び替え",
  },
  ru: {
    "Shipping Worldwide": "Доставка по всему миру",
    "Footer.openSource.title": "Открытый исходный код",
    "Footer.openSource.github": "Организация GitHub",
    "Footer.mediaKit": "Медиакит",
    "Supported Crypto": "Поддерживаемые криптовалюты",
    "supportedCrypto.seoTitle": "Поддерживаемые криптовалюты | LUKKEY",
    "supportedCrypto.seoDescription":
      "Ищите поддерживаемые блокчейны, монеты и токены в текущем списке активов приложения LUKKEY.",
    "supportedCrypto.badge": "Текущий список приложения LUKKEY",
    "supportedCrypto.title": "Поиск поддерживаемой криптовалюты",
    "supportedCrypto.search.placeholder": "Искать BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Поиск поддерживаемых криптоактивов",
    "supportedCrypto.search.clear": "Очистить поиск",
    "supportedCrypto.filter.chain": "Фильтр сети",
    "supportedCrypto.filter.networkLabel": "Сеть",
    "supportedCrypto.filter.allChains": "Все сети",
    "supportedCrypto.filter.all": "Все",
    "supportedCrypto.filter.native": "Нативные",
    "supportedCrypto.filter.tokens": "Токены",
    "supportedCrypto.table.asset": "Актив",
    "supportedCrypto.table.network": "Сеть",
    "supportedCrypto.table.type": "Тип",
    "supportedCrypto.type.native": "Нативный",
    "supportedCrypto.status.supported": "Поддерживается",
    "supportedCrypto.empty.title": "Совпадений не найдено",
    "supportedCrypto.empty.body":
      "Попробуйте другой символ монеты, название токена или блокчейн-сеть.",
    "WarrantySupport.toast.successTitle": "Запрос отправлен",
    "WarrantySupport.toast.dismiss": "Закрыть уведомление",
    "HelpCenter.tutorials.badge": "Обучение продукту",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Смотрите официальные видео по настройке, приложению, адресной книге, NFT, прошивке и паролю в плейлисте Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Открыть весь плейлист",
    "HelpCenter.tutorials.videoCta": "Смотреть урок",
    "WarrantySupport.form.cooldown": "Подождите {{seconds}} с",
    "WarrantySupport.validation.cooldown": "Подождите {{seconds}} секунд перед отправкой нового запроса.",
    "WarrantySupport.validation.maxLength": "Максимум {{max}} символов.",
    "WarrantySupport.validation.email": "Введите действительный адрес электронной почты.",
    "WarrantySupport.validation.required": "Это поле обязательно.",
    "home.secureChip.title": "Технология защищенного чипа EAL6+",
    "home.secureChip.description":
      "Чип EAL6+ обеспечивает надежную защиту ваших цифровых активов от несанкционированного доступа и киберугроз.",
    "home.multiAccount.title": "3 кошелька в одном Lukkey",
    "home.multiAccount.description":
      "Три независимых кошелька на одном устройстве, каждый со своей фразой восстановления.",
    "delivery.seoTitle": "Сроки международной доставки | LUKKEY",
    "delivery.seoDescription":
      "Просматривайте поддерживаемые регионы, сроки доставки и стоимость международной отправки.",
    "delivery.badge": "Международная доставка",
    "delivery.title": "Сроки доставки",
    "delivery.subtitle":
      "Смотрите покрытие международной доставки LUKKEY, ориентировочные сроки и стоимость отправки по актуальным рыночным данным.",
    "delivery.search.placeholder": "Поиск страны",
    "delivery.table.country": "Страна",
    "delivery.table.delivery": "Доставка",
    "delivery.table.cost": "Стоимость доставки, USD",
    "delivery.filter.allDeliveries": "Все сроки доставки",
    "delivery.filter.allCosts": "Все стоимости",
    "delivery.meta":
      "Показано {{count}} поддерживаемых регионов. Страница {{page}} из {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} рабочих дней",
    "delivery.sortLabel": "Сортировка",
  },
  ko: {
    "Shipping Worldwide": "전 세계 배송",
    "Footer.openSource.title": "오픈 소스",
    "Footer.openSource.github": "GitHub 조직",
    "Footer.mediaKit": "미디어 키트",
    "Supported Crypto": "지원 암호화폐",
    "supportedCrypto.seoTitle": "지원 암호화폐 | LUKKEY",
    "supportedCrypto.seoDescription":
      "현재 LUKKEY 앱 자산 목록에서 지원되는 블록체인, 코인, 토큰을 검색하세요.",
    "supportedCrypto.badge": "현재 LUKKEY 앱 목록",
    "supportedCrypto.title": "지원 암호화폐 검색",
    "supportedCrypto.search.placeholder": "BTC, USDT, BSC, TRC20 검색...",
    "supportedCrypto.search.label": "지원 암호화폐 자산 검색",
    "supportedCrypto.search.clear": "검색 지우기",
    "supportedCrypto.filter.chain": "네트워크 필터",
    "supportedCrypto.filter.networkLabel": "네트워크",
    "supportedCrypto.filter.allChains": "모든 네트워크",
    "supportedCrypto.filter.all": "전체",
    "supportedCrypto.filter.native": "네이티브",
    "supportedCrypto.filter.tokens": "토큰",
    "supportedCrypto.table.asset": "자산",
    "supportedCrypto.table.network": "네트워크",
    "supportedCrypto.table.type": "유형",
    "supportedCrypto.type.native": "네이티브",
    "supportedCrypto.status.supported": "지원됨",
    "supportedCrypto.empty.title": "일치하는 자산이 없습니다",
    "supportedCrypto.empty.body":
      "다른 코인 심볼, 토큰 이름 또는 블록체인 네트워크를 입력해 보세요.",
    "WarrantySupport.toast.successTitle": "요청이 제출되었습니다",
    "WarrantySupport.toast.dismiss": "알림 닫기",
    "HelpCenter.tutorials.badge": "제품 튜토리얼",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Lukkey Tutorials 재생목록에서 설정, 앱, 주소록, NFT, 펌웨어, 비밀번호 공식 튜토리얼을 확인하세요.",
    "HelpCenter.tutorials.playlistCta": "전체 재생목록 보기",
    "HelpCenter.tutorials.videoCta": "튜토리얼 보기",
    "WarrantySupport.form.cooldown": "{{seconds}}초 대기",
    "WarrantySupport.validation.cooldown": "다른 요청을 제출하기 전에 {{seconds}}초 기다려 주세요.",
    "WarrantySupport.validation.maxLength": "최대 {{max}}자까지 입력할 수 있습니다.",
    "WarrantySupport.validation.email": "올바른 이메일 주소를 입력하세요.",
    "WarrantySupport.validation.required": "필수 입력 항목입니다.",
    "home.secureChip.title": "EAL6+ 보안 칩 기술",
    "home.secureChip.description":
      "EAL6+ 보안 칩을 탑재해 무단 접근과 사이버 위협으로부터 디지털 자산을 강력하게 보호합니다.",
    "home.multiAccount.title": "하나의 Lukkey에 3개 지갑",
    "home.multiAccount.description":
      "하나의 기기에서 3개의 독립 지갑을 관리할 수 있으며 각각 고유한 복구 문구를 가집니다.",
    "delivery.seoTitle": "국제 배송 일정 | LUKKEY",
    "delivery.seoDescription":
      "지원 지역, 예상 배송 기간, 국제 배송비를 확인하세요.",
    "delivery.badge": "국제 배송",
    "delivery.title": "배송 기간",
    "delivery.subtitle":
      "LUKKEY의 국제 배송 가능 지역, 예상 배송 기간, 배송비를 현재 시장 기준에 맞춰 확인하세요.",
    "delivery.search.placeholder": "국가 검색",
    "delivery.table.country": "국가",
    "delivery.table.delivery": "배송",
    "delivery.table.cost": "배송비, USD",
    "delivery.filter.allDeliveries": "전체 배송 기간",
    "delivery.filter.allCosts": "전체 배송비",
    "delivery.meta":
      "{{count}}개 지원 지역 표시 중. {{page}} / {{totalPages}} 페이지.",
    "delivery.range.businessDays": "{{min}}-{{max}} 영업일",
    "delivery.sortLabel": "정렬",
  },
  pt: {
    "Shipping Worldwide": "Envio para todo o mundo",
    "Footer.openSource.title": "Código aberto",
    "Footer.openSource.github": "Organização no GitHub",
    "Footer.mediaKit": "Media kit",
    "Supported Crypto": "Criptomoedas compatíveis",
    "supportedCrypto.seoTitle": "Criptomoedas compatíveis | LUKKEY",
    "supportedCrypto.seoDescription":
      "Pesquise blockchains, moedas e tokens compatíveis na lista atual de ativos da app LUKKEY.",
    "supportedCrypto.badge": "Lista atual da app LUKKEY",
    "supportedCrypto.title": "Pesquisar criptomoedas compatíveis",
    "supportedCrypto.search.placeholder": "Pesquisar BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Pesquisar criptoativos compatíveis",
    "supportedCrypto.search.clear": "Limpar pesquisa",
    "supportedCrypto.filter.chain": "Filtro de rede",
    "supportedCrypto.filter.networkLabel": "Rede",
    "supportedCrypto.filter.allChains": "Todas as redes",
    "supportedCrypto.filter.all": "Tudo",
    "supportedCrypto.filter.native": "Nativa",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Ativo",
    "supportedCrypto.table.network": "Rede",
    "supportedCrypto.table.type": "Tipo",
    "supportedCrypto.type.native": "Nativa",
    "supportedCrypto.status.supported": "Compatível",
    "supportedCrypto.empty.title": "Nenhum ativo encontrado",
    "supportedCrypto.empty.body":
      "Experimente outro símbolo, nome de token ou rede blockchain.",
    "WarrantySupport.toast.successTitle": "Pedido enviado",
    "WarrantySupport.toast.dismiss": "Fechar notificação",
    "HelpCenter.tutorials.badge": "Tutoriais do produto",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Veja tutoriais oficiais de configuração, app, livro de endereços, NFT, firmware e senha na playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Ver playlist completa",
    "HelpCenter.tutorials.videoCta": "Ver tutorial",
    "WarrantySupport.form.cooldown": "Aguarde {{seconds}} s",
    "WarrantySupport.validation.cooldown": "Aguarde {{seconds}} segundos antes de enviar outro pedido.",
    "WarrantySupport.validation.maxLength": "Máximo de {{max}} caracteres.",
    "WarrantySupport.validation.email": "Introduza um endereço de email válido.",
    "WarrantySupport.validation.required": "Este campo é obrigatório.",
    "home.secureChip.title": "Tecnologia de chip seguro EAL6+",
    "home.secureChip.description":
      "Equipado com um chip seguro EAL6+, oferece proteção robusta aos seus ativos digitais contra acessos não autorizados e ameaças cibernéticas.",
    "home.multiAccount.title": "3 carteiras em um só Lukkey",
    "home.multiAccount.description":
      "Três carteiras separadas em um único dispositivo, cada uma com sua própria frase de recuperação.",
    "delivery.seoTitle": "Prazos de entrega internacional | LUKKEY",
    "delivery.seoDescription":
      "Consulte regiões suportadas, prazos de entrega e custos de envio internacional.",
    "delivery.badge": "Entrega internacional",
    "delivery.title": "Prazos de entrega",
    "delivery.subtitle":
      "Veja a cobertura de envio internacional da LUKKEY, os prazos estimados e os custos de envio com base nas referências atuais do mercado.",
    "delivery.search.placeholder": "Pesquisar país",
    "delivery.table.country": "País",
    "delivery.table.delivery": "Entrega",
    "delivery.table.cost": "Custo de envio, USD",
    "delivery.filter.allDeliveries": "Todos os prazos",
    "delivery.filter.allCosts": "Todos os custos",
    "delivery.meta":
      "A mostrar {{count}} regiões suportadas. Página {{page}} de {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} dias úteis",
    "delivery.sortLabel": "Ordenar",
  },
  "pt-BR": {
    "Shipping Worldwide": "Envio para todo o mundo",
    "Footer.openSource.title": "Código aberto",
    "Footer.openSource.github": "Organização no GitHub",
    "Footer.mediaKit": "Media kit",
    "Supported Crypto": "Criptomoedas compatíveis",
    "supportedCrypto.seoTitle": "Criptomoedas compatíveis | LUKKEY",
    "supportedCrypto.seoDescription":
      "Pesquise blockchains, moedas e tokens compatíveis na lista atual de ativos do app LUKKEY.",
    "supportedCrypto.badge": "Lista atual do app LUKKEY",
    "supportedCrypto.title": "Pesquisar criptomoedas compatíveis",
    "supportedCrypto.search.placeholder": "Pesquisar BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Pesquisar criptoativos compatíveis",
    "supportedCrypto.search.clear": "Limpar pesquisa",
    "supportedCrypto.filter.chain": "Filtro de rede",
    "supportedCrypto.filter.networkLabel": "Rede",
    "supportedCrypto.filter.allChains": "Todas as redes",
    "supportedCrypto.filter.all": "Tudo",
    "supportedCrypto.filter.native": "Nativa",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Ativo",
    "supportedCrypto.table.network": "Rede",
    "supportedCrypto.table.type": "Tipo",
    "supportedCrypto.type.native": "Nativa",
    "supportedCrypto.status.supported": "Compatível",
    "supportedCrypto.empty.title": "Nenhum ativo encontrado",
    "supportedCrypto.empty.body":
      "Tente outro símbolo, nome de token ou rede blockchain.",
    "WarrantySupport.toast.successTitle": "Solicitação enviada",
    "WarrantySupport.toast.dismiss": "Fechar notificação",
    "HelpCenter.tutorials.badge": "Tutoriais do produto",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Veja tutoriais oficiais de configuração, app, catálogo de endereços, NFT, firmware e senha na playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Ver playlist completa",
    "HelpCenter.tutorials.videoCta": "Ver tutorial",
    "WarrantySupport.form.cooldown": "Aguarde {{seconds}} s",
    "WarrantySupport.validation.cooldown": "Aguarde {{seconds}} segundos antes de enviar outra solicitação.",
    "WarrantySupport.validation.maxLength": "Máximo de {{max}} caracteres.",
    "WarrantySupport.validation.email": "Informe um endereço de e-mail válido.",
    "WarrantySupport.validation.required": "Este campo é obrigatório.",
    "home.secureChip.title": "Tecnologia de chip seguro EAL6+",
    "home.secureChip.description":
      "Equipado com um chip seguro EAL6+, oferece proteção robusta aos seus ativos digitais contra acessos não autorizados e ameaças cibernéticas.",
    "home.multiAccount.title": "3 carteiras em um só Lukkey",
    "home.multiAccount.description":
      "Três carteiras separadas em um único dispositivo, cada uma com sua própria frase de recuperação.",
    "delivery.seoTitle": "Prazos de entrega internacional | LUKKEY",
    "delivery.seoDescription":
      "Consulte regiões suportadas, prazos de entrega e custos de frete internacional.",
    "delivery.badge": "Entrega internacional",
    "delivery.title": "Prazos de entrega",
    "delivery.subtitle":
      "Veja a cobertura de envio internacional da LUKKEY, os prazos estimados e os custos de frete com base nas referências atuais do mercado.",
    "delivery.search.placeholder": "Pesquisar país",
    "delivery.table.country": "País",
    "delivery.table.delivery": "Entrega",
    "delivery.table.cost": "Custo do frete, USD",
    "delivery.filter.allDeliveries": "Todos os prazos",
    "delivery.filter.allCosts": "Todos os fretes",
    "delivery.meta":
      "Mostrando {{count}} regiões suportadas. Página {{page}} de {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} dias úteis",
    "delivery.sortLabel": "Ordenar",
  },
  it: {
    "Shipping Worldwide": "Spedizione in tutto il mondo",
    "Footer.openSource.title": "Open source",
    "Footer.openSource.github": "Organizzazione GitHub",
    "Footer.mediaKit": "Media kit",
    "Supported Crypto": "Criptovalute supportate",
    "supportedCrypto.seoTitle": "Criptovalute supportate | LUKKEY",
    "supportedCrypto.seoDescription":
      "Cerca blockchain, coin e token supportati nell'elenco attuale degli asset dell'app LUKKEY.",
    "supportedCrypto.badge": "Elenco attuale dell'app LUKKEY",
    "supportedCrypto.title": "Cerca criptovalute supportate",
    "supportedCrypto.search.placeholder": "Cerca BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Cerca crypto asset supportati",
    "supportedCrypto.search.clear": "Cancella ricerca",
    "supportedCrypto.filter.chain": "Filtro rete",
    "supportedCrypto.filter.networkLabel": "Rete",
    "supportedCrypto.filter.allChains": "Tutte le reti",
    "supportedCrypto.filter.all": "Tutto",
    "supportedCrypto.filter.native": "Nativa",
    "supportedCrypto.filter.tokens": "Token",
    "supportedCrypto.table.asset": "Asset",
    "supportedCrypto.table.network": "Rete",
    "supportedCrypto.table.type": "Tipo",
    "supportedCrypto.type.native": "Nativa",
    "supportedCrypto.status.supported": "Supportato",
    "supportedCrypto.empty.title": "Nessun asset corrispondente",
    "supportedCrypto.empty.body":
      "Prova un altro simbolo, nome token o rete blockchain.",
    "WarrantySupport.toast.successTitle": "Richiesta inviata",
    "WarrantySupport.toast.dismiss": "Chiudi notifica",
    "HelpCenter.tutorials.badge": "Tutorial prodotto",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Guarda i tutorial ufficiali su configurazione, app, rubrica, NFT, firmware e password nella playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Vedi playlist completa",
    "HelpCenter.tutorials.videoCta": "Guarda il tutorial",
    "WarrantySupport.form.cooldown": "Attendi {{seconds}} s",
    "WarrantySupport.validation.cooldown": "Attendi {{seconds}} secondi prima di inviare un’altra richiesta.",
    "WarrantySupport.validation.maxLength": "Massimo {{max}} caratteri.",
    "WarrantySupport.validation.email": "Inserisci un indirizzo email valido.",
    "WarrantySupport.validation.required": "Questo campo è obbligatorio.",
    "home.secureChip.title": "Tecnologia del chip sicuro EAL6+",
    "home.secureChip.description":
      "Dotato di chip sicuro EAL6+, offre una protezione robusta ai tuoi asset digitali contro accessi non autorizzati e minacce informatiche.",
    "home.multiAccount.title": "3 wallet in un solo Lukkey",
    "home.multiAccount.description":
      "Tre wallet separati su un unico dispositivo, ciascuno con la propria frase di recupero.",
    "delivery.seoTitle": "Tempi di consegna internazionali | LUKKEY",
    "delivery.seoDescription":
      "Consulta regioni supportate, tempi di consegna e costi di spedizione internazionale.",
    "delivery.badge": "Spedizione internazionale",
    "delivery.title": "Tempi di consegna",
    "delivery.subtitle":
      "Consulta la copertura internazionale di LUKKEY, i tempi di consegna stimati e i costi di spedizione in base ai riferimenti di mercato attuali.",
    "delivery.search.placeholder": "Cerca paese",
    "delivery.table.country": "Paese",
    "delivery.table.delivery": "Consegna",
    "delivery.table.cost": "Costo di spedizione, USD",
    "delivery.filter.allDeliveries": "Tutti i tempi di consegna",
    "delivery.filter.allCosts": "Tutti i costi",
    "delivery.meta":
      "Mostrate {{count}} regioni supportate. Pagina {{page}} di {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} giorni lavorativi",
    "delivery.sortLabel": "Ordina",
  },
  de: {
    "Shipping Worldwide": "Weltweiter Versand",
    "Footer.openSource.title": "Open Source",
    "Footer.openSource.github": "GitHub-Organisation",
    "Footer.mediaKit": "Media Kit",
    "Supported Crypto": "Unterstützte Kryptowährungen",
    "supportedCrypto.seoTitle": "Unterstützte Kryptowährungen | LUKKEY",
    "supportedCrypto.seoDescription":
      "Suche nach unterstützten Blockchains, Coins und Tokens in der aktuellen Asset-Liste der LUKKEY App.",
    "supportedCrypto.badge": "Aktuelle LUKKEY App-Liste",
    "supportedCrypto.title": "Unterstützte Kryptowährung suchen",
    "supportedCrypto.search.placeholder": "BTC, USDT, BSC, TRC20 suchen...",
    "supportedCrypto.search.label": "Unterstützte Kryptoassets suchen",
    "supportedCrypto.search.clear": "Suche löschen",
    "supportedCrypto.filter.chain": "Netzwerkfilter",
    "supportedCrypto.filter.networkLabel": "Netzwerk",
    "supportedCrypto.filter.allChains": "Alle Netzwerke",
    "supportedCrypto.filter.all": "Alle",
    "supportedCrypto.filter.native": "Nativ",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Asset",
    "supportedCrypto.table.network": "Netzwerk",
    "supportedCrypto.table.type": "Typ",
    "supportedCrypto.type.native": "Nativ",
    "supportedCrypto.status.supported": "Unterstützt",
    "supportedCrypto.empty.title": "Keine passenden Assets",
    "supportedCrypto.empty.body":
      "Versuche ein anderes Coin-Symbol, einen Token-Namen oder ein Blockchain-Netzwerk.",
    "WarrantySupport.toast.successTitle": "Anfrage gesendet",
    "WarrantySupport.toast.dismiss": "Benachrichtigung schließen",
    "HelpCenter.tutorials.badge": "Produkt-Tutorials",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Sehen Sie offizielle Tutorials zu Einrichtung, App, Adressbuch, NFT, Firmware und Passwort in der Playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Gesamte Playlist ansehen",
    "HelpCenter.tutorials.videoCta": "Tutorial ansehen",
    "WarrantySupport.form.cooldown": "{{seconds}} s warten",
    "WarrantySupport.validation.cooldown": "Bitte warten Sie {{seconds}} Sekunden, bevor Sie eine weitere Anfrage senden.",
    "WarrantySupport.validation.maxLength": "Maximal {{max}} Zeichen.",
    "WarrantySupport.validation.email": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "WarrantySupport.validation.required": "Dieses Feld ist erforderlich.",
    "home.secureChip.title": "EAL6+ Secure-Chip-Technologie",
    "home.secureChip.description":
      "Ausgestattet mit einem EAL6+ Sicherheitschip schützt LUKKEY deine digitalen Vermögenswerte zuverlässig vor unbefugtem Zugriff und Cyberbedrohungen.",
    "home.multiAccount.title": "3 Wallets in einem Lukkey",
    "home.multiAccount.description":
      "Drei separate Wallets auf einem Gerät, jeweils mit eigener Recovery Phrase.",
    "delivery.seoTitle": "Internationale Lieferzeiten | LUKKEY",
    "delivery.seoDescription":
      "Sieh dir unterstützte Regionen, Lieferzeiten und internationale Versandkosten an.",
    "delivery.badge": "Internationaler Versand",
    "delivery.title": "Lieferzeiten",
    "delivery.subtitle":
      "Sieh dir die internationale Versandabdeckung von LUKKEY, geschätzte Lieferzeiten und Versandkosten anhand aktueller Marktwerte an.",
    "delivery.search.placeholder": "Land suchen",
    "delivery.table.country": "Land",
    "delivery.table.delivery": "Lieferung",
    "delivery.table.cost": "Versandkosten, USD",
    "delivery.filter.allDeliveries": "Alle Lieferzeiten",
    "delivery.filter.allCosts": "Alle Versandkosten",
    "delivery.meta":
      "{{count}} unterstützte Regionen werden angezeigt. Seite {{page}} von {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} Werktage",
    "delivery.sortLabel": "Sortieren",
  },
  hi: {
    "Shipping Worldwide": "दुनियाभर में शिपिंग",
    "Footer.openSource.title": "ओपन सोर्स",
    "Footer.openSource.github": "GitHub संगठन",
    "Footer.mediaKit": "मीडिया किट",
    "Supported Crypto": "समर्थित क्रिप्टो",
    "supportedCrypto.seoTitle": "समर्थित क्रिप्टो | LUKKEY",
    "supportedCrypto.seoDescription":
      "मौजूदा LUKKEY ऐप एसेट सूची में समर्थित ब्लॉकचेन, कॉइन और टोकन खोजें।",
    "supportedCrypto.badge": "मौजूदा LUKKEY ऐप सूची",
    "supportedCrypto.title": "समर्थित क्रिप्टो खोजें",
    "supportedCrypto.search.placeholder": "BTC, USDT, BSC, TRC20 खोजें...",
    "supportedCrypto.search.label": "समर्थित क्रिप्टो एसेट खोजें",
    "supportedCrypto.search.clear": "खोज साफ़ करें",
    "supportedCrypto.filter.chain": "नेटवर्क फ़िल्टर",
    "supportedCrypto.filter.networkLabel": "नेटवर्क",
    "supportedCrypto.filter.allChains": "सभी नेटवर्क",
    "supportedCrypto.filter.all": "सभी",
    "supportedCrypto.filter.native": "नेटिव",
    "supportedCrypto.filter.tokens": "टोकन",
    "supportedCrypto.table.asset": "एसेट",
    "supportedCrypto.table.network": "नेटवर्क",
    "supportedCrypto.table.type": "प्रकार",
    "supportedCrypto.type.native": "नेटिव",
    "supportedCrypto.status.supported": "समर्थित",
    "supportedCrypto.empty.title": "कोई मेल खाता एसेट नहीं",
    "supportedCrypto.empty.body":
      "किसी अन्य कॉइन सिंबल, टोकन नाम या ब्लॉकचेन नेटवर्क को आज़माएँ।",
    "WarrantySupport.toast.successTitle": "अनुरोध भेज दिया गया",
    "WarrantySupport.toast.dismiss": "सूचना बंद करें",
    "HelpCenter.tutorials.badge": "प्रोडक्ट ट्यूटोरियल",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Lukkey Tutorials प्लेलिस्ट में सेटअप, ऐप, एड्रेस बुक, NFT, फर्मवेयर और पासवर्ड के आधिकारिक ट्यूटोरियल देखें।",
    "HelpCenter.tutorials.playlistCta": "पूरी प्लेलिस्ट देखें",
    "HelpCenter.tutorials.videoCta": "ट्यूटोरियल देखें",
    "WarrantySupport.form.cooldown": "{{seconds}} सेकंड प्रतीक्षा करें",
    "WarrantySupport.validation.cooldown": "दूसरा अनुरोध भेजने से पहले {{seconds}} सेकंड प्रतीक्षा करें।",
    "WarrantySupport.validation.maxLength": "अधिकतम {{max}} अक्षर।",
    "WarrantySupport.validation.email": "एक मान्य ईमेल पता दर्ज करें।",
    "WarrantySupport.validation.required": "यह फ़ील्ड आवश्यक है।",
    "home.secureChip.title": "EAL6+ सुरक्षित चिप तकनीक",
    "home.secureChip.description":
      "EAL6+ सुरक्षित चिप से लैस, यह आपके डिजिटल एसेट्स को अनधिकृत एक्सेस और साइबर खतरों से मजबूत सुरक्षा देता है।",
    "home.multiAccount.title": "एक Lukkey में 3 वॉलेट",
    "home.multiAccount.description":
      "एक ही डिवाइस में तीन अलग-अलग वॉलेट, प्रत्येक की अपनी रिकवरी फ्रेज के साथ।",
    "delivery.seoTitle": "अंतरराष्ट्रीय डिलीवरी समय | LUKKEY",
    "delivery.seoDescription":
      "समर्थित क्षेत्रों, डिलीवरी समयसीमा और अंतरराष्ट्रीय शिपिंग लागत देखें।",
    "delivery.badge": "अंतरराष्ट्रीय डिलीवरी",
    "delivery.title": "डिलीवरी समयसीमा",
    "delivery.subtitle":
      "LUKKEY की अंतरराष्ट्रीय शिपिंग कवरेज, अनुमानित डिलीवरी समय और शिपिंग लागत वर्तमान बाजार संदर्भ के साथ देखें।",
    "delivery.search.placeholder": "देश खोजें",
    "delivery.table.country": "देश",
    "delivery.table.delivery": "डिलीवरी",
    "delivery.table.cost": "शिपिंग लागत, USD",
    "delivery.filter.allDeliveries": "सभी डिलीवरी रेंज",
    "delivery.filter.allCosts": "सभी शिपिंग लागत",
    "delivery.meta":
      "{{count}} समर्थित क्षेत्र दिखाए जा रहे हैं। पृष्ठ {{page}} / {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} कार्यदिवस",
    "delivery.sortLabel": "क्रमबद्ध करें",
  },
  mn: {
    "Shipping Worldwide": "Дэлхий даяар хүргэлт",
    "Footer.openSource.title": "Нээлттэй эх",
    "Footer.openSource.github": "GitHub байгууллага",
    "Footer.mediaKit": "Медиа кит",
    "Supported Crypto": "Дэмжигдсэн крипто",
    "supportedCrypto.seoTitle": "Дэмжигдсэн крипто | LUKKEY",
    "supportedCrypto.seoDescription":
      "Одоогийн LUKKEY аппын asset жагсаалтад дэмжигдсэн blockchain, coin болон token-уудыг хайна уу.",
    "supportedCrypto.badge": "Одоогийн LUKKEY аппын жагсаалт",
    "supportedCrypto.title": "Дэмжигдсэн крипто хайх",
    "supportedCrypto.search.placeholder": "BTC, USDT, BSC, TRC20 хайх...",
    "supportedCrypto.search.label": "Дэмжигдсэн крипто asset хайх",
    "supportedCrypto.search.clear": "Хайлтыг цэвэрлэх",
    "supportedCrypto.filter.chain": "Сүлжээний шүүлтүүр",
    "supportedCrypto.filter.networkLabel": "Сүлжээ",
    "supportedCrypto.filter.allChains": "Бүх сүлжээ",
    "supportedCrypto.filter.all": "Бүгд",
    "supportedCrypto.filter.native": "Native",
    "supportedCrypto.filter.tokens": "Token",
    "supportedCrypto.table.asset": "Asset",
    "supportedCrypto.table.network": "Сүлжээ",
    "supportedCrypto.table.type": "Төрөл",
    "supportedCrypto.type.native": "Native",
    "supportedCrypto.status.supported": "Дэмжигдсэн",
    "supportedCrypto.empty.title": "Тохирох asset олдсонгүй",
    "supportedCrypto.empty.body":
      "Өөр coin symbol, token нэр эсвэл blockchain сүлжээ оруулж үзнэ үү.",
    "WarrantySupport.toast.successTitle": "Хүсэлт илгээгдлээ",
    "WarrantySupport.toast.dismiss": "Мэдэгдлийг хаах",
    "HelpCenter.tutorials.badge": "Бүтээгдэхүүний заавар",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Lukkey Tutorials тоглуулах жагсаалтаас тохиргоо, апп, хаягийн дэвтэр, NFT, firmware болон нууц үгийн албан ёсны зааврыг үзээрэй.",
    "HelpCenter.tutorials.playlistCta": "Бүтэн жагсаалтыг үзэх",
    "HelpCenter.tutorials.videoCta": "Зааврыг үзэх",
    "WarrantySupport.form.cooldown": "{{seconds}} сек хүлээнэ үү",
    "WarrantySupport.validation.cooldown": "Дахин хүсэлт илгээхээс өмнө {{seconds}} секунд хүлээнэ үү.",
    "WarrantySupport.validation.maxLength": "Хамгийн ихдээ {{max}} тэмдэгт.",
    "WarrantySupport.validation.email": "Зөв имэйл хаяг оруулна уу.",
    "WarrantySupport.validation.required": "Энэ талбарыг заавал бөглөнө.",
    "home.secureChip.title": "EAL6+ хамгаалалтын чип технологи",
    "home.secureChip.description":
      "EAL6+ хамгаалалтын чипээр тоноглогдсон тул таны дижитал хөрөнгийг зөвшөөрөлгүй хандалт болон цахим аюулаас найдвартай хамгаална.",
    "home.multiAccount.title": "Нэг Lukkey-д 3 wallet",
    "home.multiAccount.description":
      "Нэг төхөөрөмж дээр 3 тусдаа wallet, тус бүр өөрийн сэргээх phrase-тэй.",
    "delivery.seoTitle": "Олон улсын хүргэлтийн хугацаа | LUKKEY",
    "delivery.seoDescription":
      "Дэмжигдсэн бүсүүд, хүргэлтийн хугацаа болон олон улсын тээврийн үнийг үзнэ үү.",
    "delivery.badge": "Олон улсын хүргэлт",
    "delivery.title": "Хүргэлтийн хугацаа",
    "delivery.subtitle":
      "LUKKEY-ийн олон улсын хүргэлтийн хамрах хүрээ, хүрэх хугацааны тооцоо болон тээврийн үнийг одоогийн зах зээлийн лавлагаатай харьцуулан үзнэ үү.",
    "delivery.search.placeholder": "Улс хайх",
    "delivery.table.country": "Улс",
    "delivery.table.delivery": "Хүргэлт",
    "delivery.table.cost": "Хүргэлтийн үнэ, USD",
    "delivery.filter.allDeliveries": "Бүх хугацаа",
    "delivery.filter.allCosts": "Бүх үнэ",
    "delivery.meta":
      "{{count}} дэмжигдсэн бүсийг харуулж байна. {{page}} / {{totalPages}} хуудас.",
    "delivery.range.businessDays": "{{min}}-{{max}} ажлын өдөр",
    "delivery.sortLabel": "Эрэмбэлэх",
  },
  th: {
    "Shipping Worldwide": "จัดส่งทั่วโลก",
    "Footer.openSource.title": "โอเพนซอร์ส",
    "Footer.openSource.github": "องค์กร GitHub",
    "Footer.mediaKit": "มีเดียคิต",
    "Supported Crypto": "คริปโตที่รองรับ",
    "supportedCrypto.seoTitle": "คริปโตที่รองรับ | LUKKEY",
    "supportedCrypto.seoDescription":
      "ค้นหา blockchain, coin และ token ที่รองรับในรายการสินทรัพย์ปัจจุบันของแอป LUKKEY",
    "supportedCrypto.badge": "รายการแอป LUKKEY ปัจจุบัน",
    "supportedCrypto.title": "ค้นหาคริปโตที่รองรับ",
    "supportedCrypto.search.placeholder": "ค้นหา BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "ค้นหาสินทรัพย์คริปโตที่รองรับ",
    "supportedCrypto.search.clear": "ล้างการค้นหา",
    "supportedCrypto.filter.chain": "ตัวกรองเครือข่าย",
    "supportedCrypto.filter.networkLabel": "เครือข่าย",
    "supportedCrypto.filter.allChains": "ทุกเครือข่าย",
    "supportedCrypto.filter.all": "ทั้งหมด",
    "supportedCrypto.filter.native": "Native",
    "supportedCrypto.filter.tokens": "Token",
    "supportedCrypto.table.asset": "สินทรัพย์",
    "supportedCrypto.table.network": "เครือข่าย",
    "supportedCrypto.table.type": "ประเภท",
    "supportedCrypto.type.native": "Native",
    "supportedCrypto.status.supported": "รองรับ",
    "supportedCrypto.empty.title": "ไม่พบสินทรัพย์ที่ตรงกัน",
    "supportedCrypto.empty.body":
      "ลองใช้สัญลักษณ์เหรียญ ชื่อ token หรือเครือข่าย blockchain อื่น",
    "WarrantySupport.toast.successTitle": "ส่งคำขอแล้ว",
    "WarrantySupport.toast.dismiss": "ปิดการแจ้งเตือน",
    "HelpCenter.tutorials.badge": "บทเรียนผลิตภัณฑ์",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "ดูบทเรียนอย่างเป็นทางการเกี่ยวกับการตั้งค่า แอป สมุดที่อยู่ NFT เฟิร์มแวร์ และรหัสผ่านจากเพลย์ลิสต์ Lukkey Tutorials",
    "HelpCenter.tutorials.playlistCta": "ดูเพลย์ลิสต์ทั้งหมด",
    "HelpCenter.tutorials.videoCta": "ดูบทเรียน",
    "WarrantySupport.form.cooldown": "รอ {{seconds}} วินาที",
    "WarrantySupport.validation.cooldown": "โปรดรอ {{seconds}} วินาทีก่อนส่งคำขอใหม่",
    "WarrantySupport.validation.maxLength": "สูงสุด {{max}} อักขระ",
    "WarrantySupport.validation.email": "กรุณากรอกอีเมลที่ถูกต้อง",
    "WarrantySupport.validation.required": "จำเป็นต้องกรอกช่องนี้",
    "home.secureChip.title": "เทคโนโลยีชิปความปลอดภัย EAL6+",
    "home.secureChip.description":
      "มาพร้อมชิปความปลอดภัย EAL6+ เพื่อปกป้องสินทรัพย์ดิจิทัลของคุณจากการเข้าถึงที่ไม่ได้รับอนุญาตและภัยคุกคามทางไซเบอร์",
    "home.multiAccount.title": "3 วอลเล็ตใน Lukkey เครื่องเดียว",
    "home.multiAccount.description":
      "สามวอลเล็ตแยกกันในอุปกรณ์เดียว แต่ละวอลเล็ตมี recovery phrase ของตัวเอง",
    "delivery.seoTitle": "ระยะเวลาการจัดส่งระหว่างประเทศ | LUKKEY",
    "delivery.seoDescription":
      "ดูภูมิภาคที่รองรับ ระยะเวลาจัดส่ง และค่าจัดส่งระหว่างประเทศ",
    "delivery.badge": "การจัดส่งระหว่างประเทศ",
    "delivery.title": "ระยะเวลาการจัดส่ง",
    "delivery.subtitle":
      "ดูพื้นที่ที่ LUKKEY จัดส่งระหว่างประเทศ ระยะเวลาจัดส่งโดยประมาณ และค่าจัดส่งโดยอ้างอิงจากข้อมูลตลาดปัจจุบัน",
    "delivery.search.placeholder": "ค้นหาประเทศ",
    "delivery.table.country": "ประเทศ",
    "delivery.table.delivery": "การจัดส่ง",
    "delivery.table.cost": "ค่าจัดส่ง, USD",
    "delivery.filter.allDeliveries": "ทุกช่วงเวลา",
    "delivery.filter.allCosts": "ทุกค่าจัดส่ง",
    "delivery.meta":
      "กำลังแสดง {{count}} พื้นที่ที่รองรับ หน้า {{page}} จาก {{totalPages}}",
    "delivery.range.businessDays": "{{min}}-{{max}} วันทำการ",
    "delivery.sortLabel": "เรียงลำดับ",
  },
  uk: {
    "Shipping Worldwide": "Доставка по всьому світу",
    "Footer.openSource.title": "Відкритий код",
    "Footer.openSource.github": "Організація GitHub",
    "Footer.mediaKit": "Медіакіт",
    "Supported Crypto": "Підтримувані криптовалюти",
    "supportedCrypto.seoTitle": "Підтримувані криптовалюти | LUKKEY",
    "supportedCrypto.seoDescription":
      "Шукайте підтримувані блокчейни, монети й токени в поточному списку активів застосунку LUKKEY.",
    "supportedCrypto.badge": "Поточний список застосунку LUKKEY",
    "supportedCrypto.title": "Пошук підтримуваної криптовалюти",
    "supportedCrypto.search.placeholder": "Шукати BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Пошук підтримуваних криптоактивів",
    "supportedCrypto.search.clear": "Очистити пошук",
    "supportedCrypto.filter.chain": "Фільтр мережі",
    "supportedCrypto.filter.networkLabel": "Мережа",
    "supportedCrypto.filter.allChains": "Усі мережі",
    "supportedCrypto.filter.all": "Усі",
    "supportedCrypto.filter.native": "Нативні",
    "supportedCrypto.filter.tokens": "Токени",
    "supportedCrypto.table.asset": "Актив",
    "supportedCrypto.table.network": "Мережа",
    "supportedCrypto.table.type": "Тип",
    "supportedCrypto.type.native": "Нативний",
    "supportedCrypto.status.supported": "Підтримується",
    "supportedCrypto.empty.title": "Немає збігів",
    "supportedCrypto.empty.body":
      "Спробуйте інший символ монети, назву токена або блокчейн-мережу.",
    "WarrantySupport.toast.successTitle": "Запит надіслано",
    "WarrantySupport.toast.dismiss": "Закрити сповіщення",
    "HelpCenter.tutorials.badge": "Навчання продукту",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Дивіться офіційні відео про налаштування, застосунок, адресну книгу, NFT, прошивку та пароль у плейлисті Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Переглянути весь плейлист",
    "HelpCenter.tutorials.videoCta": "Дивитися урок",
    "WarrantySupport.form.cooldown": "Зачекайте {{seconds}} с",
    "WarrantySupport.validation.cooldown": "Зачекайте {{seconds}} секунд перед надсиланням нового запиту.",
    "WarrantySupport.validation.maxLength": "Максимум {{max}} символів.",
    "WarrantySupport.validation.email": "Введіть дійсну адресу електронної пошти.",
    "WarrantySupport.validation.required": "Це поле обов’язкове.",
    "home.secureChip.title": "Технологія захищеного чипа EAL6+",
    "home.secureChip.description":
      "Оснащений захищеним чипом EAL6+, який надійно захищає ваші цифрові активи від несанкціонованого доступу та кіберзагроз.",
    "home.multiAccount.title": "3 гаманці в одному Lukkey",
    "home.multiAccount.description":
      "Три окремі гаманці на одному пристрої, кожен зі своєю фразою відновлення.",
    "delivery.seoTitle": "Терміни міжнародної доставки | LUKKEY",
    "delivery.seoDescription":
      "Переглядайте підтримувані регіони, строки доставки та вартість міжнародного відправлення.",
    "delivery.badge": "Міжнародна доставка",
    "delivery.title": "Терміни доставки",
    "delivery.subtitle":
      "Перегляньте покриття міжнародної доставки LUKKEY, орієнтовні строки та вартість доставки за актуальними ринковими орієнтирами.",
    "delivery.search.placeholder": "Пошук країни",
    "delivery.table.country": "Країна",
    "delivery.table.delivery": "Доставка",
    "delivery.table.cost": "Вартість доставки, USD",
    "delivery.filter.allDeliveries": "Усі терміни",
    "delivery.filter.allCosts": "Усі вартості",
    "delivery.meta":
      "Показано {{count}} підтримуваних регіонів. Сторінка {{page}} з {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} робочих днів",
    "delivery.sortLabel": "Сортувати",
  },
  vi: {
    "Shipping Worldwide": "Giao hàng toàn cầu",
    "Footer.openSource.title": "Mã nguồn mở",
    "Footer.openSource.github": "Tổ chức GitHub",
    "Footer.mediaKit": "Media kit",
    "Supported Crypto": "Tiền mã hóa được hỗ trợ",
    "supportedCrypto.seoTitle": "Tiền mã hóa được hỗ trợ | LUKKEY",
    "supportedCrypto.seoDescription":
      "Tìm blockchain, coin và token được hỗ trợ trong danh sách tài sản hiện tại của ứng dụng LUKKEY.",
    "supportedCrypto.badge": "Danh sách hiện tại của ứng dụng LUKKEY",
    "supportedCrypto.title": "Tìm tiền mã hóa được hỗ trợ",
    "supportedCrypto.search.placeholder": "Tìm BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Tìm tài sản mã hóa được hỗ trợ",
    "supportedCrypto.search.clear": "Xóa tìm kiếm",
    "supportedCrypto.filter.chain": "Bộ lọc mạng",
    "supportedCrypto.filter.networkLabel": "Mạng",
    "supportedCrypto.filter.allChains": "Tất cả mạng",
    "supportedCrypto.filter.all": "Tất cả",
    "supportedCrypto.filter.native": "Gốc",
    "supportedCrypto.filter.tokens": "Token",
    "supportedCrypto.table.asset": "Tài sản",
    "supportedCrypto.table.network": "Mạng",
    "supportedCrypto.table.type": "Loại",
    "supportedCrypto.type.native": "Gốc",
    "supportedCrypto.status.supported": "Được hỗ trợ",
    "supportedCrypto.empty.title": "Không có tài sản phù hợp",
    "supportedCrypto.empty.body":
      "Thử ký hiệu coin, tên token hoặc mạng blockchain khác.",
    "WarrantySupport.toast.successTitle": "Yêu cầu đã gửi",
    "WarrantySupport.toast.dismiss": "Đóng thông báo",
    "HelpCenter.tutorials.badge": "Hướng dẫn sản phẩm",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Xem hướng dẫn chính thức về thiết lập, ứng dụng, sổ địa chỉ, NFT, firmware và mật khẩu trong playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Xem toàn bộ playlist",
    "HelpCenter.tutorials.videoCta": "Xem hướng dẫn",
    "WarrantySupport.form.cooldown": "Chờ {{seconds}} giây",
    "WarrantySupport.validation.cooldown": "Vui lòng chờ {{seconds}} giây trước khi gửi yêu cầu khác.",
    "WarrantySupport.validation.maxLength": "Tối đa {{max}} ký tự.",
    "WarrantySupport.validation.email": "Nhập địa chỉ email hợp lệ.",
    "WarrantySupport.validation.required": "Trường này là bắt buộc.",
    "home.secureChip.title": "Công nghệ chip bảo mật EAL6+",
    "home.secureChip.description":
      "Được trang bị chip bảo mật EAL6+, thiết bị bảo vệ tài sản số của bạn trước truy cập trái phép và các mối đe dọa mạng.",
    "home.multiAccount.title": "3 ví trong một Lukkey",
    "home.multiAccount.description":
      "Ba ví riêng biệt trên một thiết bị, mỗi ví có cụm từ khôi phục riêng.",
    "delivery.seoTitle": "Thời gian giao hàng quốc tế | LUKKEY",
    "delivery.seoDescription":
      "Xem các khu vực được hỗ trợ, thời gian giao hàng và chi phí vận chuyển quốc tế.",
    "delivery.badge": "Giao hàng quốc tế",
    "delivery.title": "Thời gian giao hàng",
    "delivery.subtitle":
      "Xem phạm vi giao hàng quốc tế của LUKKEY, thời gian giao hàng ước tính và chi phí vận chuyển theo tham chiếu thị trường hiện tại.",
    "delivery.search.placeholder": "Tìm quốc gia",
    "delivery.table.country": "Quốc gia",
    "delivery.table.delivery": "Giao hàng",
    "delivery.table.cost": "Phí vận chuyển, USD",
    "delivery.filter.allDeliveries": "Tất cả thời gian",
    "delivery.filter.allCosts": "Tất cả mức phí",
    "delivery.meta":
      "Đang hiển thị {{count}} khu vực được hỗ trợ. Trang {{page}} / {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} ngày làm việc",
    "delivery.sortLabel": "Sắp xếp",
  },
  id: {
    "Shipping Worldwide": "Pengiriman ke seluruh dunia",
    "Footer.openSource.title": "Sumber terbuka",
    "Footer.openSource.github": "Organisasi GitHub",
    "Footer.mediaKit": "Media kit",
    "Supported Crypto": "Kripto yang didukung",
    "supportedCrypto.seoTitle": "Kripto yang didukung | LUKKEY",
    "supportedCrypto.seoDescription":
      "Cari blockchain, coin, dan token yang didukung di daftar aset aplikasi LUKKEY saat ini.",
    "supportedCrypto.badge": "Daftar aplikasi LUKKEY saat ini",
    "supportedCrypto.title": "Cari kripto yang didukung",
    "supportedCrypto.search.placeholder": "Cari BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Cari aset kripto yang didukung",
    "supportedCrypto.search.clear": "Hapus pencarian",
    "supportedCrypto.filter.chain": "Filter jaringan",
    "supportedCrypto.filter.networkLabel": "Jaringan",
    "supportedCrypto.filter.allChains": "Semua jaringan",
    "supportedCrypto.filter.all": "Semua",
    "supportedCrypto.filter.native": "Native",
    "supportedCrypto.filter.tokens": "Token",
    "supportedCrypto.table.asset": "Aset",
    "supportedCrypto.table.network": "Jaringan",
    "supportedCrypto.table.type": "Tipe",
    "supportedCrypto.type.native": "Native",
    "supportedCrypto.status.supported": "Didukung",
    "supportedCrypto.empty.title": "Tidak ada aset yang cocok",
    "supportedCrypto.empty.body":
      "Coba simbol coin, nama token, atau jaringan blockchain lain.",
    "WarrantySupport.toast.successTitle": "Permintaan terkirim",
    "WarrantySupport.toast.dismiss": "Tutup notifikasi",
    "HelpCenter.tutorials.badge": "Tutorial produk",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Tonton tutorial resmi untuk setup, aplikasi, buku alamat, NFT, firmware, dan kata sandi dari playlist Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Lihat playlist lengkap",
    "HelpCenter.tutorials.videoCta": "Tonton tutorial",
    "WarrantySupport.form.cooldown": "Tunggu {{seconds}} dtk",
    "WarrantySupport.validation.cooldown": "Harap tunggu {{seconds}} detik sebelum mengirim permintaan lain.",
    "WarrantySupport.validation.maxLength": "Maksimum {{max}} karakter.",
    "WarrantySupport.validation.email": "Masukkan alamat email yang valid.",
    "WarrantySupport.validation.required": "Kolom ini wajib diisi.",
    "home.secureChip.title": "Teknologi chip aman EAL6+",
    "home.secureChip.description":
      "Dilengkapi chip aman EAL6+ untuk melindungi aset digital Anda dari akses tidak sah dan ancaman siber.",
    "home.multiAccount.title": "3 wallet dalam satu Lukkey",
    "home.multiAccount.description":
      "Tiga wallet terpisah dalam satu perangkat, masing-masing dengan recovery phrase sendiri.",
    "delivery.seoTitle": "Estimasi pengiriman internasional | LUKKEY",
    "delivery.seoDescription":
      "Lihat wilayah yang didukung, estimasi waktu pengiriman, dan biaya kirim internasional.",
    "delivery.badge": "Pengiriman internasional",
    "delivery.title": "Estimasi pengiriman",
    "delivery.subtitle":
      "Lihat cakupan pengiriman internasional LUKKEY, estimasi waktu kirim, dan biaya pengiriman berdasarkan referensi pasar saat ini.",
    "delivery.search.placeholder": "Cari negara",
    "delivery.table.country": "Negara",
    "delivery.table.delivery": "Pengiriman",
    "delivery.table.cost": "Biaya kirim, USD",
    "delivery.filter.allDeliveries": "Semua estimasi",
    "delivery.filter.allCosts": "Semua biaya",
    "delivery.meta":
      "Menampilkan {{count}} wilayah yang didukung. Halaman {{page}} dari {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} hari kerja",
    "delivery.sortLabel": "Urutkan",
  },
  tl: {
    "Shipping Worldwide": "Pandaigdigang pagpapadala",
    "Footer.openSource.title": "Open source",
    "Footer.openSource.github": "Organisasyon sa GitHub",
    "Footer.mediaKit": "Media kit",
    "Supported Crypto": "Suportadong crypto",
    "supportedCrypto.seoTitle": "Suportadong crypto | LUKKEY",
    "supportedCrypto.seoDescription":
      "Maghanap ng suportadong blockchain, coin, at token sa kasalukuyang asset list ng LUKKEY app.",
    "supportedCrypto.badge": "Kasalukuyang listahan ng LUKKEY app",
    "supportedCrypto.title": "Maghanap ng suportadong crypto",
    "supportedCrypto.search.placeholder": "Hanapin ang BTC, USDT, BSC, TRC20...",
    "supportedCrypto.search.label": "Maghanap ng suportadong crypto assets",
    "supportedCrypto.search.clear": "I-clear ang search",
    "supportedCrypto.filter.chain": "Network filter",
    "supportedCrypto.filter.networkLabel": "Network",
    "supportedCrypto.filter.allChains": "Lahat ng network",
    "supportedCrypto.filter.all": "Lahat",
    "supportedCrypto.filter.native": "Native",
    "supportedCrypto.filter.tokens": "Tokens",
    "supportedCrypto.table.asset": "Asset",
    "supportedCrypto.table.network": "Network",
    "supportedCrypto.table.type": "Uri",
    "supportedCrypto.type.native": "Native",
    "supportedCrypto.status.supported": "Suportado",
    "supportedCrypto.empty.title": "Walang tumugmang asset",
    "supportedCrypto.empty.body":
      "Subukan ang ibang coin symbol, token name, o blockchain network.",
    "WarrantySupport.toast.successTitle": "Naipadala ang request",
    "WarrantySupport.toast.dismiss": "Isara ang notification",
    "HelpCenter.tutorials.badge": "Mga tutorial ng produkto",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Panoorin ang opisyal na setup, app, address book, NFT, firmware, at password tutorials mula sa playlist na Lukkey Tutorials.",
    "HelpCenter.tutorials.playlistCta": "Tingnan ang buong playlist",
    "HelpCenter.tutorials.videoCta": "Panoorin ang tutorial",
    "WarrantySupport.form.cooldown": "Maghintay {{seconds}}s",
    "WarrantySupport.validation.cooldown": "Maghintay ng {{seconds}} segundo bago magsumite ng isa pang request.",
    "WarrantySupport.validation.maxLength": "Hanggang {{max}} character lamang.",
    "WarrantySupport.validation.email": "Maglagay ng valid na email address.",
    "WarrantySupport.validation.required": "Kinakailangan ang field na ito.",
    "home.secureChip.title": "Teknolohiyang EAL6+ secure chip",
    "home.secureChip.description":
      "May EAL6+ secure chip para sa matibay na proteksiyon ng iyong digital assets laban sa hindi awtorisadong access at cyber threats.",
    "home.multiAccount.title": "3 wallet sa isang Lukkey",
    "home.multiAccount.description":
      "Tatlong magkakahiwalay na wallet sa isang device, bawat isa ay may sariling recovery phrase.",
    "delivery.seoTitle": "International delivery timeframes | LUKKEY",
    "delivery.seoDescription":
      "Tingnan ang mga suportadong rehiyon, delivery timeframe, at gastos sa pandaigdigang pagpapadala.",
    "delivery.badge": "International delivery",
    "delivery.title": "Delivery timeframes",
    "delivery.subtitle":
      "Tingnan ang international shipping coverage ng LUKKEY kasama ang tinatayang delivery timeframes at shipping costs batay sa kasalukuyang market references.",
    "delivery.search.placeholder": "Maghanap ng bansa",
    "delivery.table.country": "Bansa",
    "delivery.table.delivery": "Delivery",
    "delivery.table.cost": "Gastos sa shipping, USD",
    "delivery.filter.allDeliveries": "Lahat ng delivery range",
    "delivery.filter.allCosts": "Lahat ng shipping cost",
    "delivery.meta":
      "Ipinapakita ang {{count}} suportadong rehiyon. Pahina {{page}} ng {{totalPages}}.",
    "delivery.range.businessDays": "{{min}}-{{max}} araw ng negosyo",
    "delivery.sortLabel": "Ayusin",
  },
  bn: {
    "Shipping Worldwide": "বিশ্বব্যাপী শিপিং",
    "Footer.openSource.title": "ওপেন সোর্স",
    "Footer.openSource.github": "GitHub সংস্থা",
    "Footer.mediaKit": "মিডিয়া কিট",
    "Supported Crypto": "সমর্থিত ক্রিপ্টো",
    "supportedCrypto.seoTitle": "সমর্থিত ক্রিপ্টো | LUKKEY",
    "supportedCrypto.seoDescription":
      "বর্তমান LUKKEY অ্যাপ asset তালিকায় সমর্থিত blockchain, coin ও token খুঁজুন।",
    "supportedCrypto.badge": "বর্তমান LUKKEY অ্যাপ তালিকা",
    "supportedCrypto.title": "সমর্থিত ক্রিপ্টো খুঁজুন",
    "supportedCrypto.search.placeholder": "BTC, USDT, BSC, TRC20 খুঁজুন...",
    "supportedCrypto.search.label": "সমর্থিত crypto asset খুঁজুন",
    "supportedCrypto.search.clear": "সার্চ মুছুন",
    "supportedCrypto.filter.chain": "নেটওয়ার্ক ফিল্টার",
    "supportedCrypto.filter.networkLabel": "নেটওয়ার্ক",
    "supportedCrypto.filter.allChains": "সব নেটওয়ার্ক",
    "supportedCrypto.filter.all": "সব",
    "supportedCrypto.filter.native": "Native",
    "supportedCrypto.filter.tokens": "Token",
    "supportedCrypto.table.asset": "Asset",
    "supportedCrypto.table.network": "নেটওয়ার্ক",
    "supportedCrypto.table.type": "ধরন",
    "supportedCrypto.type.native": "Native",
    "supportedCrypto.status.supported": "সমর্থিত",
    "supportedCrypto.empty.title": "মিলে যাওয়া asset নেই",
    "supportedCrypto.empty.body":
      "অন্য coin symbol, token name বা blockchain network চেষ্টা করুন।",
    "WarrantySupport.toast.successTitle": "অনুরোধ জমা হয়েছে",
    "WarrantySupport.toast.dismiss": "নোটিফিকেশন বন্ধ করুন",
    "HelpCenter.tutorials.badge": "প্রোডাক্ট টিউটোরিয়াল",
    "HelpCenter.tutorials.title": "Lukkey Tutorials",
    "HelpCenter.tutorials.subtitle": "Lukkey Tutorials প্লেলিস্টে সেটআপ, অ্যাপ, অ্যাড্রেস বুক, NFT, ফার্মওয়্যার ও পাসওয়ার্ডের অফিসিয়াল টিউটোরিয়াল দেখুন।",
    "HelpCenter.tutorials.playlistCta": "সম্পূর্ণ প্লেলিস্ট দেখুন",
    "HelpCenter.tutorials.videoCta": "টিউটোরিয়াল দেখুন",
    "WarrantySupport.form.cooldown": "{{seconds}} সেকেন্ড অপেক্ষা করুন",
    "WarrantySupport.validation.cooldown": "আরেকটি অনুরোধ পাঠানোর আগে {{seconds}} সেকেন্ড অপেক্ষা করুন।",
    "WarrantySupport.validation.maxLength": "সর্বোচ্চ {{max}} অক্ষর।",
    "WarrantySupport.validation.email": "একটি বৈধ ইমেইল ঠিকানা লিখুন।",
    "WarrantySupport.validation.required": "এই ক্ষেত্রটি আবশ্যক।",
    "home.secureChip.title": "EAL6+ সিকিউর চিপ প্রযুক্তি",
    "home.secureChip.description":
      "EAL6+ সিকিউর চিপসহ সজ্জিত, যা অননুমোদিত প্রবেশ ও সাইবার হুমকি থেকে আপনার ডিজিটাল সম্পদকে সুরক্ষিত রাখে।",
    "home.multiAccount.title": "একটি Lukkey-তে ৩টি ওয়ালেট",
    "home.multiAccount.description":
      "এক ডিভাইসে তিনটি আলাদা ওয়ালেট, প্রতিটির নিজস্ব recovery phrase রয়েছে।",
    "delivery.seoTitle": "আন্তর্জাতিক ডেলিভারি সময়সীমা | LUKKEY",
    "delivery.seoDescription":
      "সমর্থিত অঞ্চল, ডেলিভারি সময়সীমা এবং আন্তর্জাতিক শিপিং খরচ দেখুন।",
    "delivery.badge": "আন্তর্জাতিক ডেলিভারি",
    "delivery.title": "ডেলিভারি সময়সীমা",
    "delivery.subtitle":
      "LUKKEY-এর আন্তর্জাতিক শিপিং কভারেজ, সম্ভাব্য ডেলিভারি সময় এবং শিপিং খরচ বর্তমান বাজার রেফারেন্সসহ দেখুন।",
    "delivery.search.placeholder": "দেশ খুঁজুন",
    "delivery.table.country": "দেশ",
    "delivery.table.delivery": "ডেলিভারি",
    "delivery.table.cost": "শিপিং খরচ, USD",
    "delivery.filter.allDeliveries": "সব ডেলিভারি রেঞ্জ",
    "delivery.filter.allCosts": "সব শিপিং খরচ",
    "delivery.meta":
      "{{count}}টি সমর্থিত অঞ্চল দেখানো হচ্ছে। পৃষ্ঠা {{page}} / {{totalPages}}।",
    "delivery.range.businessDays": "{{min}}-{{max}} কর্মদিবস",
    "delivery.sortLabel": "সাজান",
  },
};
